import * as React from "react";
import * as cn from "classnames/bind";
import * as styles from "./zenta-color-picker.css";
import { ChromePicker } from "react-color";
import { useState, useEffect, useRef } from "react";
import Button from "content/button/button";
import { color } from "d3";

interface ZentaColorPickerProps {
    onClick: (selectedColorId: any) => void;
    colors: Array<ZentaColorPickerItem>;
    selectedItemId?: any;
    bigButtons?: boolean;
    applyGradient?: boolean;
    colorsWithBorder?: Array<any>;
    removeMarginBottom?: boolean;
    selectedColor?: string;
    setCustomColor?: (hex: string) => void;
    useColorPicker?: boolean;
}

export interface ZentaColorPickerItem {
    id: any;
    hexColor: string;
    applyGradient?: boolean;
}

const ZentaColorPicker: React.SFC<ZentaColorPickerProps> = ({
    onClick,
    colors,
    selectedItemId,
    bigButtons = false,
    colorsWithBorder = [],
    removeMarginBottom = false,
    selectedColor = "#FFFFFF",
    setCustomColor = () => {},
    useColorPicker = false,
}) => {
    const [showColorPicker, setShowColorPicker] = useState(false);

    const myRef: any = useRef();

    const handleClickOutside = (e: any) => {
        if (!myRef.current.contains(e.target)) {
            setShowColorPicker(false);
        }
    };

    useEffect(() => {
        if (useColorPicker) {
            document.addEventListener("mousedown", handleClickOutside);
            return () =>
                document.removeEventListener("mousedown", handleClickOutside);
        }
    }, []);

    const cx = cn.bind(styles);

    const colorPickerCss = () =>
        cx({
            colorPicker: true,
            colorPickerRemoveBottomMargin: removeMarginBottom,
        });

    const colorPickerItemCss = (
        useBig: boolean = false,
        applyGradient: boolean = false,
        isSelected: boolean,
        addBorder: boolean,
    ) =>
        cx({
            colorPickerItem: true,
            colorPickerItemBig: useBig,
            gradientCss: applyGradient,
            colorPickerItemSelected: isSelected,
            addBorder: addBorder,
        });

    const colorPickerLiCss = () =>
        cx({
            colorPickerLi: true,
        });

    return (
        <div
            style={{ position: "relative" }}
            onBlur={() => {
                setShowColorPicker(false);
            }}>
            <ul className={colorPickerCss()}>
                {colors.map((colorItem) => (
                    <li className={colorPickerLiCss()} key={colorItem.id}>
                        <div
                            onClick={() =>
                                onClick(
                                    colorItem.id === selectedItemId
                                        ? (null as any)
                                        : colorItem.id,
                                )
                            }
                            className={colorPickerItemCss(
                                bigButtons,
                                colorItem.applyGradient,
                                colorItem.id === selectedItemId,
                                colorsWithBorder.some(
                                    (x) => x === colorItem.id,
                                ),
                            )}
                            style={{ background: colorItem.hexColor }}
                        />
                    </li>
                ))}
                {useColorPicker && (
                    <li className={colorPickerLiCss()}>
                        <div
                            style={{
                                position: "relative",
                                backgroundImage:
                                    "url(images/color-palette.svg)",
                            }}
                            onClick={() => setShowColorPicker(!showColorPicker)}
                            className={colorPickerItemCss(
                                bigButtons,
                                false,
                                selectedItemId === -1,
                                false,
                            )}
                        />
                    </li>
                )}
            </ul>
            {useColorPicker && (
                <div
                    ref={myRef}
                    style={{
                        position: "absolute",
                        display: showColorPicker ? "block" : "none",
                        zIndex: 200,
                        left: "50%",
                        transform: "translate(-50%,0)",
                        top: "20px",
                        touchAction: "none",
                    }}>
                    <div
                        style={{
                            position: "absolute",
                            top: "-25px",
                            right: "0px",
                            zIndex: 9999,
                            backgroundColor: "#f1f1f1",
                            border: "1px solid #d6d6d6",
                            width: "25px",
                            height: "25px",
                            textAlign: "center",
                        }}>
                        <i
                            style={{ cursor: "pointer" }}
                            className={"fas fa-times"}
                            onClick={() => {
                                setShowColorPicker(false);
                            }}
                        />
                    </div>
                    <ChromePicker
                        color={selectedColor ? selectedColor : "#ffffff"}
                        onChangeComplete={(color: any) => {
                            if (color) {
                                setCustomColor(color.hex);
                            }
                        }}
                        disableAlpha={true}
                    />
                </div>
            )}
        </div>
    );
};

export default ZentaColorPicker;
